<template>
  <div class="law_search main-page"
       id="law_page">
    <Menu :title="title"
          :home="true">
      <template slot="right-link">
        <div class="servicePoint">
        </div>
      </template>
    </Menu>
    <div class="container-flex law-wrap">
      <div class="law-left">
        <div class="hts">
          <span>
            筛选条件
          </span>

        </div>
        <div class="htn">
          <div class="input-item">
            <label for="">关键字：</label>
            <input type="text"
                   @keyup.13="search"
                   v-model="searchModel.keywords"
                   placeholder="请输入法律法规关键字">
          </div>
          <div class="input-item">
            <label for="">所属专业：</label>
            <lv-cascader :treeData="professionalList"
                         v-model="searchModel.professionalId">
              <div slot="title">请选择专业</div>
            </lv-cascader>
          </div>
          <div class="input-item">
            <label for="">地区：</label>
            <areaSelector :value="searchModel.areaId"
                          @on-select="seleteArea"
                          @on-clear="searchModel.areaId = ''">
            </areaSelector>
          </div>
          <div class="input-item">
            <label for="">法律文号：</label>
            <input type="text"
                   @keyup.13="search"
                   v-model="searchModel.documentNumber"
                   placeholder="请输入法律文号">
          </div>
          <div class="input-item start-item">
            <label for="">发布单位：</label>
            <lv-multiple :arrayData="orgs"
                         v-if="orgs.length"
                         v-model="searchModel.orgIds"
                         placeholder="请选择发布单位">
            </lv-multiple>
          </div>
          <div class="input-item">
            <label for="">行业分类：</label>
            <input type="text"
                   v-model="ingSets"
                   readonly="readonly"
                   placeholder="请选择行业分类，可多选"
                   @focus="insStatus = true">
          </div>
          <div class="input-item">
            <label for="">效力等级：</label>
            <select v-model="searchModel.forceLevel">
              <option v-for="item of forceLevel"
                      :key="item.value"
                      :value="item.value">
                {{ item.title }}
              </option>
            </select>
          </div>
          <div class="input-item">
            <label for="">效力状态：</label>
            <select v-model="searchModel.forceStatus">
              <option v-for="item of forceStatus"
                      :key="item.value"
                      :value="item.value">
                {{ item.title }}
              </option>
            </select>
          </div>
          <div class="input-item">
            <label for="">施行开始：</label>
            <input type="date"
                   placeholder="请选择日期"
                   v-model="searchModel.enforcementStartDate"
                   class="in-date">
          </div>
          <div class="input-item">
            <label for="">施行结束：</label>
            <input type="date"
                   placeholder="请选择日期"
                   v-model="searchModel.enforcementEndDate"
                   class="in-date">
          </div>
          <div class="input-item">
            <label for="">失效开始：</label>
            <input type="date"
                   placeholder="请选择日期"
                   v-model="searchModel.expiryStartDate"
                   class="in-date">
          </div>
          <div class="input-item">
            <label for="">失效结束：</label>
            <input type="date"
                   placeholder="请选择日期"
                   v-model="searchModel.expiryEndDate"
                   class="in-date">
          </div>
          <div class="input-item">
            <label for="">发布开始：</label>
            <input type="date"
                   placeholder="请选择日期"
                   v-model="searchModel.issueStartDate"
                   class="in-date">
          </div>
          <div class="input-item">
            <label for="">发布结束：</label>
            <input type="date"
                   placeholder="请选择日期"
                   v-model="searchModel.issueEndDate"
                   class="in-date">
          </div>
        </div>
        <div class="btns">
          <button class="active"
                  @click="search(true)">确定</button>
          <button @click="clearCondition">清空</button>
        </div>
      </div>
      <div class="law-right noscroll"
           id="law-right"
           v-infinite-scroll="loadmore"
           :infinite-scroll-disabled="loading"
           infinite-scroll-distance="10">
        <div v-if="lawList && lawList.length">
          <div class="item"
               v-for="(item, index) in lawList"
               :key="'key-' + index"
               @click.stop="toDetail(item)">
            <!-- @click="$router.push('/LawDetail?faguiId='+item.id)" -->
            <div class="title">
              <span>{{ item.name }}</span>
            </div>
            <div class="detail">实施：{{ $moment(item.enforcementDate).format('YYYY-MM-DD HH:mm') }} 丨
              时效性：{{ item.forceStatus }}</div>
          </div>
          <div class="loadoverinfo "
               v-if="loadover">
            <span>
              已全部加载
            </span>
          </div>
        </div>
        <div class="empty-info"
             v-if="isLoading && !lawList.length">
          <img src="/img/ui/law/no-result.png">
          <p>没有相关法律法规哦～</p>
        </div>
      </div>
    </div>

    <OrgModal :ins="industrys"
              v-model="insStatus"
              @change="changeIns"></OrgModal>
  </div>
</template>
<script>
import Menu from '@/components/Menu'
import areaSelector from '@/components/area-selector'
import * as lawApi from '../../datas/js/law'
import Cascader from '@/components/lv-cascader'
import Multiple from '@/components/lv-multiple-choice'
import OrgModal from '@/components/OrgModal'

export default {
  components: {
    Menu,
    areaSelector,
    'lv-cascader': Cascader,
    'lv-multiple': Multiple,
    OrgModal
  },
  data () {
    return {
      title: '',
      lawList: [],
      model: {
        pageSize: 30,
        pageNo: 0,
        count: 0
      },
      searchModel: {
        lawName: '', // 法律名称
        keywords: '', // 关键字
        documentNumber: '', // 法律文号
        title: '', // 第几条
        areaId: '', // 地区Id
        orgIds: '', // 发布单位
        industryIds: '', // 行业分类
        professionalId: '', // 所属专业
        forceLevel: '', // 效力等级。查看对应接口
        forceStatus: '', // 效力状态, 1有效， 2无效， 3，已修改
        enforcementStartDate: '', // 施行开始日期
        enforcementEndDate: '', // 施行结束日期
        expiryStartDate: '', // 失效开始日期
        expiryEndDate: '', // 失效结束日期
        issueStartDate: '', // 发布开始日期
        issueEndDate: '' // 发布结束日期
      },
      category_list: [],
      year: [],
      sureSearch: false,
      loadover: false,
      loading: false,
      isLoading: false, // 是否加载完
      firstloading: false,

      insStatus: false,
      ingSets: ''
    }
  },
  computed: {
    professionalList () {
      let list = this.$store.getters['lawStore/professionalList']
      return list
    },
    orgs () {
      let list = this.$store.getters['lawStore/orgs']
      return list
    },
    industrys () {
      return this.$store.getters['lawStore/industrys']
    },
    forceLevel () {
      return this.$store.getters['lawStore/forceLevel']
    },
    forceStatus () {
      return this.$store.getters['lawStore/forceStatus']
    },
    appInfo () {
      return this.$store.getters['app/getAppInfo']
    }
  },
  created () {
    if (!this.appInfo.appId) {
      this.$store.dispatch('app/getAppInfoBySite')
    }
    this.$loading.show()
    this.$store.dispatch('lawStore/getProfessionalList')
    if (!this.orgs.length) {
      this.$store.dispatch('lawStore/getOrgs')
    }
    this.$store.dispatch('lawStore/getIndustrys')
    this.$store.dispatch('lawStore/getForceLevel')
    this.$store.dispatch('lawStore/getForceStatus')
    this.firstloading = true
    const { title, keywords, forceLevel, professionalId } = this.$route.query
    this.title = title || ''
    this.searchModel.keywords = keywords || ''
    this.searchModel.forceLevel = +forceLevel || null
    this.searchModel.professionalId = professionalId || null
  },
  methods: {
    loadmore () {
      if (this.loadover) {
        return
      }
      this.loading = true
      this.model.pageNo += 1
      setTimeout(async () => {
        this.search()
        this.loading = false
      }, 1000)
    },
    getVoice () {
      window.NativeInterface.startVoiceUnderstand()
    },
    getVoiceCon (str) {
      console.log(str)
    },
    changeIns (list, ins) {
      this.searchModel.industryIds = list.join(',')
      let arr = []
      ins.forEach(item => {
        arr.push(item.name)
      })
      this.ingSets = arr.join(',')
    },
    seleteArea (data) {
      this.searchModel.areaId = data.id || ''
    },
    search (clear) {
      if (clear) {
        this.model.pageNo = 0
        this.lawList = []
      }
      const params = {
        ...this.searchModel,
        pageNo: this.model.pageNo || 1,
        pageSize: this.model.pageSize
      }
      for (let key in params) params[key] = params[key] || null
      lawApi.getLawlist(params).then(res => {
        if (res.response.success && res.data && res.data.result.length) {
          this.$loading.hide()
          this.model.pageNo = res.data.pageNo || 0
          this.lawList = this.lawList.concat(res.data.result) || []
        } else if (res.response.success && !res.data) {
          this.$loading.hide()
          this.isLoading = true
          this.lawList = []
        } else if (res.response.success && !res.data.result.length) {
          this.loadover = true
        } else {
          this.$loading.hide()
          console.log('got an error response', res.response.msg)
        }
      }).catch(error => {
        console.log('catch an error ', error)
      })
    },
    clearCondition () {
      this.model.pageNo = 0
      for (let key in this.searchModel) this.searchModel[key] = null
      this.ingSets = null
      this.orgSets = null
    },
    toDetail (item) {
      this.$router.push(`/LawDetail/${item.id}`)
    }
  }

}
</script>
<style lang="stylus" scoped>
.law_search
  height 100vh
  .law-wrap
    position relative
    padding 0.3rem 0.6rem 0.5rem 0.6rem
    box-sizing border-box
    display flex
    justify-content space-between
    .voice
      position absolute
      bottom -0.25rem
      right 5.72rem
      z-index 2
      .icon
        margin 0.15rem auto
        width 1rem
        height 1rem
        border-radius 50%
        background #30c036 url('/img/common/voice_38.png') center no-repeat
        box-shadow 0px 0.05rem 0.18rem 0px rgba(0, 42, 2, 0.35)
      span
        font-size 0.24rem
        color #fff
  .law-right
    position relative
    width 11.9rem
    height 100%
    z-index 1
    overflow-y scroll
    .item
      display block
      padding 0.45rem 0.35rem
      background-color #fff
      border-radius 0.08rem
      margin-bottom 0.3rem
      -webkit-box-sizing border-box
      box-sizing border-box
      &:last-child
        margin 0
      .title
        font-size 0.3rem
        line-height 0.45rem
        color #666
        margin-bottom 0.26rem
      .detail
        font-size 0.26rem
        color #999
    .loadoverinfo
      font-size 0.3rem
      color rgba(255, 255, 255, 0.5)
      text-align center
      span
        position relative
        padding 0 0.2rem
        &:before, &:after
          content ''
          position absolute
          top 50%
          margin-top -1px
          width 0.6rem
          height 2px
          background rgba(255, 255, 255, 0.5)
        &:before
          left -0.6rem
        &:after
          right -0.6rem
    .empty-info
      text-align center
      font-size 0.26rem
      color #fff
      img
        width 2.68rem
        height 2.68rem
        margin 2.65rem 0 0.55rem 0
  .law-left
    width 5.6rem
    z-index 1000
    height 100%
    background-color rgba(255, 255, 255, 0.2)
    border-radius 0.08rem
    border solid 1px rgba(255, 255, 255, 0.2)
    box-sizing border-box
    padding 0.15rem 0.28rem 0.15rem 0
    color #fff
    display flex
    flex-direction column
    overflow hidden
    .hts
      display flex
      justify-content space-between
      padding 0.15rem 0.15rem 0.4rem 0.15rem
      font-size 0.26rem
      text-align center
      flex-shrink 0
    .htn
      flex auto
      overflow-x hidden
      overflow-y scroll
      .input-item
        display flex
        align-items center
        line-height 0.7rem
        font-size 0.2rem
        margin-bottom 0.25rem
        label
          flex-shrink 0
          font-weight 400
          width 1.31rem
          text-align right
          font-size 0.2rem
          margin-right 0.1rem
        select, input
          outline none
          display block
          flex 1
          box-sizing border-box
          padding 0 0.05rem 0 0.1rem
          height 0.7rem
          font-size 0.22rem
          border-radius 0.06rem
          border 0
          color #fff
          background rgba(255, 255, 255, 0.2)
        select
          option
            color #333
        &.type
          .type-select
            flex 1
            overflow hidden
            display flex
            justify-content space-between
            select
              display block
              overflow hidden
              text-overflow ellipsis
              white-space nowrap
              &.one
                max-width 2.4rem
              &.two
                max-width 1.3rem
      .start-item
        align-items flex-start
      .in-date
        flex 1
        width 3.6rem
        box-sizing border-box
        padding 0 0.05rem 0 0.1rem
        height 0.7rem
        font-size 0.22rem
        border-radius 0.06rem
        border 0
        color #fff
        background rgba(255, 255, 255, 0.2)
        margin 0.12rem 0
    .btns
      flex-shrink 0
      padding-left 0.15rem
      margin-top 0.15rem
      text-align center
      display flex
      justify-content space-between
      button
        display block
        font-size 0.3rem
        flex 1
        height 0.76rem
        box-sizing border-box
        line-height 0.76rem
        border-radius 0.1rem
        background none
        border solid 2px #b6cbff
        color #fff
        &.active
          margin-right 0.2rem
          border solid 2px #2f5ccd
          background-color #2f5ccd
</style>
